import {AfterViewInit, Component, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { MetaTagService } from '../../services/meta-tag.service';
import {AdvertisementEnum} from "../../core/advertisement/advertisement.component";
import {ReelItem} from "../../components/reels-bar/reels.model";
import {ReelsService} from "../../components/reels-bar/reels.service";
import {SystemApp} from "../../constans/SystemConfigurations";

declare function LoadSliderJs(): any;

@Component({
    selector: 'app-home-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.css'],
    standalone: false
})
export class HomePageComponent implements OnInit, AfterViewInit {

  protected readonly AdvertisementEnum = AdvertisementEnum;
  reelsData: ReelItem[] = [];

  /**
   * Visual entry points into the main categories, shown at the top of the
   * page. Slugs match the existing `/shop/:id` route params already used by
   * the header's category links, so these reuse the same routes — no new
   * endpoints. Icons are inline SVG path data (24x24, stroked) to stay
   * consistent with the rest of the app rather than using emoji.
   */
  readonly shortcutCategories: { slug: string; label: string; icon: string }[] = [
    { slug: 'car',      label: 'רכב',        icon: 'M5 17h14M5 17a2 2 0 11-4 0 2 2 0 014 0zm14 0a2 2 0 11-4 0 2 2 0 014 0zM3 17v-4.5L5 7h14l2 5.5V17M6 12h12' },
    { slug: 'nadlan',   label: 'נדל"ן',      icon: 'M3 10.5L12 3l9 7.5M5.5 9.5V20h13V9.5M9.5 20v-6h5v6' },
    { slug: 'sale2',    label: 'יד שנייה',   icon: 'M6 7h12l-1 13H7L6 7zm3 0V5a3 3 0 116 0v2' },
    { slug: 'required', label: 'דרושים',     icon: 'M3 8.5h18v11H3v-11zm6 0V6a2 2 0 012-2h2a2 2 0 012 2v2.5M3 13h18' },
    { slug: 'coworker', label: 'בעלי מקצוע', icon: 'M14.5 6a3.5 3.5 0 004.6 4.3l-8.4 8.4a2.4 2.4 0 01-3.4-3.4l8.4-8.4A3.5 3.5 0 0014.5 6z' },
    { slug: 'teacher',  label: 'מורים',      icon: 'M4 4.5h6a2.5 2.5 0 012.5 2.5v13A2 2 0 0011 18.5H4v-14zm16 0h-6A2.5 2.5 0 0011.5 7v13A2 2 0 0113 18.5h7v-14z' },
    { slug: 'pet',      label: 'חיות מחמד',  icon: 'M12 21c-1.5 0-6-3.5-8-7.5C2 9 4 4 8.5 4c2 0 3 1.5 3.5 2.5C12.5 5.5 13.5 4 15.5 4 20 4 22 9 20 13.5 18 17.5 13.5 21 12 21z' },
  ];

  /** Maps resource type → CSS flex order (lower = appears first) */
  sectionOrder: {[key: string]: number} = {};

  private readonly DEFAULT_ORDER = ['Car', 'Nadlan', 'Sale2', 'Teacher', 'Pet', 'Coworker', 'Required'];
  private readonly CATEGORY_ORDER_URL = SystemApp.base_url_api + '/client-api/user/category-order/';

  constructor(
    private http: HttpClient,
    private reelsService: ReelsService,
    private seo: MetaTagService
  ) {}

  ngOnInit(): void {
    this.seo.update({
      title:       'פלטפורמת המכירות של ישראל',
      description: `מצא רכבים, נדל"ן, אלקטרוניקה ועוד ב-${this.seo.siteName} — הפלטפורמה הגדולה למודעות בישראל. פרסם בחינם עכשיו!`,
      keywords:    'מכירות, רכבים יד שניה, דירות, אלקטרוניקה, ישראל, מודעות חינם',
      url:         this.seo.pageUrl('/'),
    });

    this.reelsService.getFeed({ limit: 50 }).subscribe(res => {
      this.reelsData = res.results;
    });

    this.loadCategoryOrder();
  }

  ngAfterViewInit(): void {
    // LoadSliderJs()
  }

  /** Fetch personalized category order from backend and build the order map. */
  private loadCategoryOrder(): void {
    // AppInterceptor adds Bearer when signed in. This used to send
    // 'Token 1' (the is_logged_in marker) and touched localStorage during SSR.
    const headers = new HttpHeaders();

    this.http.get<{order: string[]}>(this.CATEGORY_ORDER_URL, { headers }).subscribe({
      next: (res) => {
        const order = res.order?.length ? res.order : this.DEFAULT_ORDER;
        order.forEach((type, index) => {
          this.sectionOrder[type] = index;
        });
      },
      error: () => {
        // On any error fall back to default
        this.DEFAULT_ORDER.forEach((type, index) => {
          this.sectionOrder[type] = index;
        });
      }
    });
  }

  /** Returns CSS flex order for a given resource type. */
  getOrder(type: string): number {
    return this.sectionOrder[type] ?? 99;
  }

  onShare($event: ReelItem) {}
  onLike($event: ReelItem) {}
  onReelClick($event: { reel: ReelItem; index: number }) {}
  onContact($event: ReelItem) {}
  onWhatsapp($event: ReelItem) {}
  onSeeAll() {}
}
